export default __webpack_public_path__ + "static/media/FacebookIconFooter.8b12bf19.svg";